import React from 'react';
import FileReader from './FileReader';  // Adjust the path based on your file structure

function App() {
  return (
    <div className="min-h-screen bg-gray-300">
      <FileReader />
    </div>
  );
}

export default App;